import React, { useMemo, useEffect, useCallback, useState, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import text from '../constants/Menu'

import Loader from 'react-loader-spinner'

import * as actions from '../redux/actions'
import sendMessageWPP from '../services/sendMessageWPP'
import TermsHandlers from '../services/TermsHandlers'
import Evaluation from '../services/Evaluation'

import IconHanger from '../assets/images/icon_hanger.svg'
import IconColorPalette from '../assets/images/icon_color_palette.svg'
import IconCalendar from '../assets/images/icon_calendar.svg'
import IconShop from '../assets/images/icon_shop.svg'
import IconUsers from '../assets/images/icon_users.svg'
import IconMaterialDeveloperBoard from '../assets/images/icon_material_developer_board.svg'
import IconDollar from '../assets/images/icon_dollar.svg'
import iconFavorite from '../assets/images/icon_favorite.svg'
// import IconShoppingCart from '../assets/images/icon_shopping_cart.svg'

import Header from '../components/Header'
import MenuButton from '../components/MenuButton'
import Popup from '../services/PopupTwoButtons'
import { FiLogOut } from 'react-icons/fi'
import { FaWhatsapp } from 'react-icons/fa'
import '../styles/containers/Menu.css'
import MenuOption from '../components/MenuOption'
import API from '../services/Api'
import { supportPhone } from '../services/defaultProps'
import { useHistory } from 'react-router-dom'
import useLanguage from '../hooks/useLanguage'

const Menu = props => {
  const { push } = useHistory()

  const language = useLanguage()
  const [isLoading, setIsLoading] = useState(false)
  const [openPopup, setOpenPopup] = useState(false)
  const [isLoadingPopup, setIsLoadingPopup] = useState(false)

  const showTrendsNotification = useMemo(() => props.numberOfNewPosts > 0, [props.numberOfNewPosts])
  const hasClosetContent = useMemo(() => props.user.userCloset.length > 0, [props.user.userCloset])
  const hasProfileContent = useMemo(() => {
    const { profileText, userProfile, userStyle, silhouetteId } = props.user
    return (!!userProfile && userProfile.length > 0) ||
      !!profileText ||
      (!!(silhouetteId) && (!!userStyle && Object.keys(userStyle).length === 0)) ||
      (!!userStyle && !!userStyle.styleImages)
  }, [
    props.user.profileText,
    props.user.userProfile,
    props.user.userStyle,
    props.user.silhouetteId
  ])
  const hasPersonalColoringContent = useMemo(() => props.user.personalColoring > 0, [props.user.personalColoring])
  const hasMoodboardContent = useMemo(() => !!props.user.userStyle, [props.user.userStyle])
  const hasShopListTemplateContent = useMemo(() =>
    (!!props.user.shopListTemplate && props.user.shopListTemplate.length > 0) ||
    (!!props.user.shopListImage && props.user.shopListImage.length > 0) ||
    (!!props.user.shopListText),
  [props.user.shopListTemplate, props.user.shopListImage, props.user.shopListText])
  const hasAgendaContent = useMemo(() => !!props.user.agenda, [props.user.agenda])
  const hasBillingsContent = useMemo(() => props.pendingBillings.length > 0, [props.pendingBillings])
  // const hasMyShoppingContent = useMemo(() => props.orders.length > 0, [props.orders])

  const handleLogout = useCallback(() => {
    props.setToken(null)
    push('/login')
    props.setUser(null)
    props.setIsAppBlocked(false)
    props.setPendingBillings([])
  }, [])

  const moodboardHaveRelease = useCallback(() => {
    return props.user.moodboardTemplate.find(category => category.released === 1)
  }, [props.user.moodboardTemplate])

  const sendWhatsappMessage = useCallback(() => sendMessageWPP(supportPhone, `Olá, sou cliente Mosty. Me chamo ${props.user.name} e desejo falar com o suporte`), [props.user.name])

  useEffect(() => {
    (async () => {
      if (props.user.fetchedInLogin) return

      const id = props.user.id
      const token = props.token

      setIsLoading(true)

      try {
        const user = await API.getUser(token)

        const profileResponse = API.getProfile(token, id)
        const profileImageResponse = API.getProfileImage(token, id)
        const styleImageResponse = API.getStyleImage(token)
        const closetResponse = API.getCloset(token, id)
        const moodboardResponse = API.getMoodboard(token, id)
        const moodboardTemplateResponse = API.getMoodboardTemplate(token)
        const shopListResponse = API.getShopList(token)
        const shopListTemplateResponse = API.getShopListTemplate(token)
        const personalColoringV2Response = API.getPersonalColoringV2(token)
        const agendaResponse = API.getAgenda(token, id)
        const personalContrastResponse = API.getPersonalContrast(token)
        const openCartResponse = API.getOpenCart(token)
        const payerInfoResponse = API.getPayerInfo(token)
        const deliveryAddressResponse = API.getDeliveryAddress(token)
        const cardResponse = API.getCard(token)
        const ordersResponse = API.getOrders(token)
        const blockStatusResponse = API.getBlockStatus(token)
        const billingListResponse = API.getBillingList(token)

        const [
          profile,
          userProfile,
          userStyle,
          userCloset, 
          moodboard,
          moodboardTemplate,
          shopList,
          shopListTemplate,
          personalColoring,
          agenda,
          userContrast,
          cart,
          payerInfo,
          deliveryAddress,
          card,
          orders,
          blockStatus,
          billingList,
          userPersonalColor 
        ] = await Promise.all([
          profileResponse,
          profileImageResponse,
          styleImageResponse,
          closetResponse,
          moodboardResponse,
          moodboardTemplateResponse,
          shopListResponse,
          shopListTemplateResponse,
          personalColoringV2Response,  // ← posição 9, alinhado com 'personalColoring'
          agendaResponse,
          personalContrastResponse,
          openCartResponse,
          payerInfoResponse,
          deliveryAddressResponse,
          cardResponse,
          ordersResponse,
          blockStatusResponse,
          billingListResponse
        ])

        props.setUser({ ...user })
        props.setUserAttribute(profile)
        props.setUserAttribute(userProfile)
        props.setUserAttribute({ userStyle })
        props.setUserAttribute(userCloset)
        props.setUserAttribute(moodboard)
        props.setUserAttribute({ moodboardTemplate })
        props.setUserAttribute({ shopListTemplate })
        props.setUserAttribute(shopList)
        props.setUserAttribute(personalColoring)
        props.setUserAttribute({ agenda })
        props.setUserAttribute(userContrast)
        props.setUserAttribute(userPersonalColor)
        props.setCart({cart})
        props.setPayerInfo({payerInfo})
        props.setDeliveryAddress({deliveryAddress})
        props.setPayerInfo({card})
        props.setOrders({orders})
        props.setUserAttribute({ lastFetch: moment() })
        props.setIsAppBlocked(blockStatus)
        props.setPendingBillings(billingList)
        props.setAllBillings(billingList)
      } catch (err) {
        if (err.statusCode === 401) {
          window.alert('A sua sessão expirou! Por favor, faça login novamente.')
          handleLogout()
        } else {
          console.log('Error fetching all attributes', err)
        }
      } finally {
        setIsLoading(false)
      }
    })()

    // request permission to send push notifications
    requestPushNotification()
  }, [])

  const getSubscriptionServiceWorker = async () => {
    try {
      const serviceWorkerRegistration = await navigator.serviceWorker.ready
      const subscription = await serviceWorkerRegistration.pushManager.getSubscription()
      return subscription
    } catch (err) {
      console.error(`Error during getSubscription(): ${err}`)
      throw err
    }
  }

  const registerNotificationSubscription = async () => {
    let subscription = await getSubscriptionServiceWorker()

    const userId = props.user.id

    if (!subscription) {
      const publicKeyResponse = await API.getPushNotificationPublicKey(props.token)

      const serviceWorkerRegistration = await navigator.serviceWorker.ready
      subscription = await serviceWorkerRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: publicKeyResponse
      })
    }

    await API.postPushNotificationRegister(props.token, { userId, subscription })
  }

  const requestNotificationPermission = async () => {
    Notification.requestPermission().then(async permission => {
      if (permission === 'granted') {
        setOpenPopup(false)
        setIsLoadingPopup(false)
        await registerNotificationSubscription()
      } else {
        setOpenPopup(false)
        setIsLoadingPopup(false)
      }
    })
  }

  const requestPushNotification = async () => {
    if ('Notification' in window) {
      if (Notification.permission === 'granted') {
        const userId = props.user.id
        const subscriptionSW = await getSubscriptionServiceWorker()

        await API.getPushNotificationSubscription(props.token, userId)
          .then(res => {
            const result = res.find(
              sub => sub.endpoint === subscriptionSW.endpoint
            )
            if (!result) {
              registerNotificationSubscription()
            }
          })
          .catch(err => console.log('Err: ', err))
      } else if (Notification.permission === 'denied') {

      } else {
        setOpenPopup(true)
      }
    }
  }

  const requestPushNotificationPopup = () => {
    return (
      <Popup
        open={openPopup}
        close={() => setOpenPopup(false)}
        closeButton={false}
        textHeader='Olá! Queremos tornar sua experiência com a mosty ainda mais incrível'
        textParagraph={
          <div>
            Aceite receber notificações para sempre ser avisada sempre que houver novidades.
            <br /><br />
            Toque em <strong>'Aceitar'</strong> agora e aproveite ao máximo nosso app.
          </div>
        }
        textButton='Aceitar'
        buttonAction={() => {
          requestNotificationPermission()
          setIsLoadingPopup(true)
        }}
        isTwoButtons
        textTwoButton='Cancelar'
        loading={isLoadingPopup}
      />
    )
  }

  return (
    <div className='menu-screen-container'>
      {requestPushNotificationPopup()}
      <TermsHandlers />
      <Evaluation />
      <Header language={language} />
      {isLoading ? (
        <div className='menu-screen-loader'>
          <Loader
            type='TailSpin'
            color='white'
            height={60}
            width={60}
          />
        </div>
      ) : (
        <Fragment>
          <div className='menu-screen-options'>
            <MenuOption icon={IconUsers} path='/perfil' hasContent={hasProfileContent}>{text.perfil[language]}</MenuOption>
            <MenuOption icon={IconColorPalette} path='/cor' hasContent={hasPersonalColoringContent}>{text.color[language]}</MenuOption>
            <MenuOption icon={IconMaterialDeveloperBoard}
              path={(props.user.moodboardTemplate && props.user.moodboardTemplate.length > 0 && moodboardHaveRelease()) ? '/moodboard/categorias' : '/moodboard'}
              hasContent={hasMoodboardContent}>
              {text.moodboard[language]}
            </MenuOption>
            <MenuOption icon={IconHanger} path='/closet' hasContent={hasClosetContent}>{text.closet[language]}</MenuOption>
            <MenuOption icon={IconShop} path={(props.user.shopListTemplate && props.user.shopListTemplate.length > 0) ? '/compras/categoria' : {pathname: '/compras', state: { category: 'upload' }}} hasContent={hasShopListTemplateContent}>{text.list[language]}</MenuOption>
            <MenuOption icon={IconCalendar} path='/agenda' hasContent={hasAgendaContent}>{text.schedule[language]}</MenuOption>
            <MenuOption icon={iconFavorite} path='/rememberyou' hasContent={showTrendsNotification}>{text.rememberedYou[language]}</MenuOption>
            <MenuOption icon={IconDollar} path='/cobrancas' hasContent={hasBillingsContent}>{text.billings[language]}</MenuOption>
          </div>
          <div className='flex1' />
          <div className='menu-screen-footer'>
            <MenuButton backgroundColor='var(--lightgreen)' Icon={FaWhatsapp} onClick={sendWhatsappMessage}>{text.support[language]}</MenuButton>
            <MenuButton backgroundColor='var(--gray)' className='menu-screen-logout'
              Icon={FiLogOut} onClick={handleLogout}>{text.logout[language]}</MenuButton>
          </div>
        </Fragment>
      )}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    ...state.userReducer,
    numberOfNewPosts: state.notificationReducer.trends.numberOfNewPosts,
    orders: state.productsReducer.orders,
    pendingBillings: state.billingAndBlockStatusReducer.pendingBillings
  }
}

export default connect(mapStateToProps, actions)(Menu)



// WEBPACK FOOTER //
// ./src/containers/Menu.js